/* Forviva thema v3 */
(function () {
  'use strict';

  var money = function (cents) {
    var fmt = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: fmt }).format(cents / 100);
    } catch (e) {
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }
  };

  /* Mobiel menu */
  function initDrawer() {
    var drawer = document.getElementById('fv-drawer');
    if (!drawer) return;
    var openBtn = document.querySelector('[data-fv-drawer-open]');
    var set = function (open) {
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', String(!open));
      if (openBtn) openBtn.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('fv-lock', open);
    };
    if (openBtn) openBtn.addEventListener('click', function () { set(true); });
    drawer.querySelectorAll('[data-fv-drawer-close]').forEach(function (el) {
      el.addEventListener('click', function () { set(false); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
  }

  /* Aankondigingsbalk: wisselen op mobiel */
  function initAnnouncement() {
    document.querySelectorAll('[data-fv-rotate]').forEach(function (bar) {
      var items = bar.querySelectorAll('.fv-announce__item');
      if (items.length < 2) return;
      var i = 0;
      var delay = (parseInt(bar.getAttribute('data-fv-rotate'), 10) || 4) * 1000;
      setInterval(function () {
        if (window.matchMedia('(min-width: 990px)').matches) return;
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, delay);
    });
  }

  /* Aantal-knoppen */
  function initQty(root) {
    (root || document).querySelectorAll('[data-fv-qty]').forEach(function (w) {
      if (w.dataset.ready) return;
      w.dataset.ready = '1';
      var input = w.querySelector('input');
      var min = parseInt(input.min || '1', 10);
      var change = function (d) {
        var v = Math.max(min, (parseInt(input.value, 10) || min) + d);
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      };
      w.querySelector('[data-fv-qty-minus]').addEventListener('click', function () { change(-1); });
      w.querySelector('[data-fv-qty-plus]').addEventListener('click', function () { change(1); });
    });
  }

  /* Video's spelen af als ze in beeld zijn */
  function initVideos() {
    var vids = document.querySelectorAll('[data-fv-autoplay] video');
    if (!vids.length) return;
    vids.forEach(function (v) { v.muted = true; v.setAttribute('playsinline', ''); });
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.pause(); }
      });
    }, { threshold: 0.35 });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* Productgalerij */
  function initGallery(root) {
    var g = root.querySelector('[data-fv-gallery]');
    if (!g) return null;
    var track = g.querySelector('[data-fv-gallery-track]');
    var slides = Array.prototype.slice.call(track.children);
    var thumbs = g.querySelectorAll('[data-fv-thumb]');
    var dots = g.querySelectorAll('.fv-gallery__dots span');
    var setActive = function (idx) {
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    };
    var goTo = function (idx) {
      if (idx < 0 || idx >= slides.length) return;
      track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      setActive(idx);
    };
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        setActive(Math.round(track.scrollLeft / track.clientWidth));
      });
    }, { passive: true });
    return {
      showMedia: function (id) {
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-media-id') === String(id)) { goTo(i); return; }
        }
      }
    };
  }

  /* Varianten, prijs en winkelwagen */
  function initProduct(root) {
    var gallery = initGallery(root);
    var json = root.querySelector('[data-fv-variants]');
    var form = root.querySelector('[data-fv-product-form]');
    var variants = json ? JSON.parse(json.textContent) : [];
    var idInput = form ? form.querySelector('[data-fv-variant-id]') : null;
    var atc = form ? form.querySelector('[data-fv-atc]') : null;
    var atcLabel = form ? form.querySelector('[data-fv-atc-label]') : null;
    var radios = root.querySelectorAll('[data-fv-option]');
    var isMain = root.classList.contains('fv-product');
    var stickyPrice = document.querySelector('[data-fv-sticky-price]');
    var stickyBtn = document.querySelector('[data-fv-sticky-btn]');

    var update = function () {
      var selected = [];
      root.querySelectorAll('[data-fv-variant-picker] fieldset').forEach(function (fs, i) {
        var c = fs.querySelector('input:checked');
        selected[i] = c ? c.value : null;
        var lbl = fs.querySelector('[data-fv-option-label]');
        if (lbl && c) lbl.textContent = c.value;
      });
      var v = variants.find(function (x) {
        return x.options.every(function (o, i) { return o === selected[i]; });
      });
      if (!v) {
        if (atc) atc.disabled = true;
        if (atcLabel) atcLabel.textContent = 'Niet beschikbaar';
        return;
      }
      if (idInput) idInput.value = v.id;
      root.querySelectorAll('[data-fv-price]').forEach(function (p) {
        var html = '<span class="fv-price__now">' + money(v.price) + '</span>';
        if (v.compare_at_price && v.compare_at_price > v.price) html += '<s class="fv-price__was">' + money(v.compare_at_price) + '</s>';
        p.innerHTML = html;
      });
      if (atc) atc.disabled = !v.available;
      if (atcLabel) atcLabel.textContent = v.available ? 'In winkelwagen' : 'Uitverkocht';
      if (isMain && stickyPrice) stickyPrice.textContent = money(v.price);
      if (isMain && stickyBtn) stickyBtn.disabled = !v.available;
      if (v.featured_media && gallery) gallery.showMedia(v.featured_media.id);
      if (isMain && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    };
    radios.forEach(function (r) { r.addEventListener('change', update); });

    if (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var btns = [atc, isMain ? stickyBtn : null].filter(Boolean);
        btns.forEach(function (b) { b.disabled = true; });
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) { if (!r.ok) throw r; return r.json(); })
          .then(function () { return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function (r) { return r.json(); }); })
          .then(function (cart) {
            document.querySelectorAll('[data-fv-cart-count]').forEach(function (c) {
              c.textContent = cart.item_count;
              c.classList.toggle('is-empty', cart.item_count === 0);
            });
            toast('Toegevoegd aan je winkelwagen', '/cart', 'Bekijk winkelwagen');
          })
          .catch(function () { form.submit(); })
          .finally(function () { btns.forEach(function (b) { b.disabled = false; }); });
      });
    }

    /* Sticky koopbalk op mobiel */
    if (isMain && atc && 'IntersectionObserver' in window) {
      var bar = document.querySelector('[data-fv-sticky-atc]');
      if (bar) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          var show = !e.isIntersecting && e.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', String(!show));
        }).observe(atc);
      }
    }
  }

  var toastEl;
  function toast(msg, href, linkText) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'fv-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<span>' + msg + '</span>' + (href ? '<a href="' + href + '">' + linkText + '</a>' : '');
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 4000);
  }

  /* Winkelwagen: aantal aanpassen = direct bijwerken */
  function initCart() {
    var form = document.querySelector('.fv-cart__form');
    if (!form) return;
    var t;
    form.querySelectorAll('[data-fv-cart-qty]').forEach(function (i) {
      i.addEventListener('change', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var h = document.createElement('input');
          h.type = 'hidden'; h.name = 'update'; h.value = '1';
          form.appendChild(h);
          form.submit();
        }, 500);
      });
    });
  }

  function init() {
    initDrawer();
    initAnnouncement();
    initQty();
    initVideos();
    document.querySelectorAll('[data-fv-product]').forEach(initProduct);
    initCart();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Thema-editor: opnieuw initialiseren als een sectie verandert */
  document.addEventListener('shopify:section:load', function (e) {
    initQty(e.target);
    initVideos();
    e.target.querySelectorAll('[data-fv-product]').forEach(initProduct);
  });
})();
